import { Component, Input, ViewChild, OnChanges, AfterViewInit,  AfterViewChecked } from '@angular/core';
import { IonicPage, Content } from 'ionic-angular';
import { ScrollDetail } from '@ionic/core';
import {datos} from '../../providers/datos';

declare var $:any ;
declare var window:any ;


@Component({
  selector: 'contactos',
  templateUrl: 'contactos.html'
})
export class contactos implements OnChanges, AfterViewInit,  AfterViewChecked{
  @Input() data: any;
  @Input() events: any;
  @ViewChild(Content)
  content: Content;

  headerImage:any = "";
  active=false;
  color="transparente";
  showToolbar = true;

  pagina={
    headerTitle:"Acerca de ocre",
    title:"Ocre nails ©2018 Todos los Derechos Reservados",
    fondo:"assets/images/app/fondo.jpg",
    subtitle:"sub tirulo",
    items:[
     
    ]

  };
  constructor(public datos:datos) {

  this.iniciar();
  }


openUrl(url){
  console.log(url);
    window.location.href = url;

}
est(){
  console.log();
}
  onEvent(event: string, item: any, e: any) {
    console.log("evento");
  }

  onStarClass(items: any, index: number, e: any) {
    for (var i = 0; i < items.length; i++) {
      items[i].isActive = i <= index;
    }
    this.onEvent("onRates", index, e);
  }

  ngOnChanges(changes: { [propKey: string]: any }) {
    console.log("change");

    if (changes.data && changes.data.currentValue) {
        this.headerImage = changes.data.currentValue.headerImage;
    }
    this.subscribeToIonScroll();
  }

  ngAfterViewInit() {
    this.subscribeToIonScroll();
  }

  ngAfterViewChecked() {
    this.subscribeToIonScroll();
  }

  isClassActive() {
    return this.active;
  }


  iniciar()
  {
    this.datos.loader(1);
    this.datos.getPagina('getContactos')
               .subscribe((data) => {
    this.datos.loader(0);

                   this.pagina = data.data;
                },
               (error: any) => {
                   console.log(error);
    this.datos.loader(0);
    // setTimeout(() => {
    //   this.iniciar();
    // }, 3000);

               });
               return this.pagina
  }



  subscribeToIonScroll() {
    console.log("screoll");

    if (this.content != null && this.content.ionScroll != null) {
      this.content.ionScroll.subscribe((d) => {
        console.log(d.scrollTop);
        if (d.scrollTop > 200 && this.active== false ) {
        console.log("cambio");
        this.active=true;
        $( "#est" ).trigger( "click" );
      }

      if (d.scrollTop < 200 && this.active== true ) {
      console.log("cambio");
      this.active=false;
      $( "#est" ).trigger( "click" );
    }


      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/contactos/contactos.ts